import { useMemo } from "react";

export const useAllowedColumns = (columns: any[]) => {
    return useMemo(() => {
        return columns.filter((column: any) => {
            if (["selection", "actions"].includes(column.id)) return false;
            if (column.hideable === false) return false;
            return true;
        });
    }, [columns]);
};
